import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="circle">
        <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
        <div className="dot dot4"></div>
        <div className="dot dot5"></div>
        <div className="dot dot6"></div>
        <div className="dot dot7"></div>
        <div className="dot dot8"></div>
        <div className="dot dot9"></div>
        <div className="dot dot10"></div>
        <div className="dot dot11"></div>
        <div className="dot dot12"></div>
        <div className="dot dot13"></div>
        <div className="dot dot14"></div>
        <div className="dot dot15"></div>
        <div className="dot dot16"></div>
        <div className="dot dot17"></div>
        <div className="dot dot18"></div>
      </div>
      <div className="circle2">
      <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
        <div className="dot dot4"></div>
        <div className="dot dot5"></div>
        <div className="dot dot6"></div>
        <div className="dot dot7"></div>
        <div className="dot dot8"></div>
        <div className="dot dot9"></div>
        <div className="dot dot10"></div>
        <div className="dot dot11"></div>
        <div className="dot dot12"></div>
        <div className="dot dot13"></div>
        <div className="dot dot14"></div>
        <div className="dot dot15"></div>
        <div className="dot dot16"></div>
        <div className="dot dot17"></div>
        <div className="dot dot18"></div>

      </div>
      <div className="circle3">
      <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
        <div className="dot dot4"></div>
        <div className="dot dot5"></div>
        <div className="dot dot6"></div>
        <div className="dot dot7"></div>
        <div className="dot dot8"></div>
        <div className="dot dot9"></div>
        <div className="dot dot10"></div>
        <div className="dot dot11"></div>
        <div className="dot dot12"></div>
        <div className="dot dot13"></div>
        <div className="dot dot14"></div>
        <div className="dot dot15"></div>
        <div className="dot dot16"></div>
        <div className="dot dot17"></div>
        <div className="dot dot18"></div>
      </div> 

    </div>
  );
};

export default Spinner;